import React from "react";
import {
  Divider,
  Header,
  Segment,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "semantic-ui-react";
import { IConveyorBoxItem } from "../../../lib/interfaces/ConveyorBox/IConveyorBox";
import ImageWithFallback from "../../ImageWithFallback/ImageWithFallback";
import { LimaShippingStatus } from "../../../utils/Constants";

type Props = {
  items: IConveyorBoxItem[];
  shippingId: number;
  shippingStatus: number;
  packageNumber: string;
};

const ShippingList = ({ items, shippingId, shippingStatus, packageNumber }: Props) => {
  return (
    <Segment size="large">
      <div className="ShippingDetails">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <span>{`Shipping: ${(shippingId !== -1 && shippingId) || "Okänt"}`}</span>
          {shippingStatus === LimaShippingStatus.Packad ? (
            <span style={{ color: "red", marginLeft: "5px" }}>(EJ UTSKRIVEN)</span>
          ) : null}
        </div>
        <span>{`Kollinummer: ${packageNumber || "Okänt"}`}</span>
      </div>
      <Divider />
      <Table celled basic="very">
        <TableHeader>
          <TableRow>
            <TableHeaderCell singleLine>SKU</TableHeaderCell>
            <TableHeaderCell></TableHeaderCell>
            <TableHeaderCell>Artikel</TableHeaderCell>
            <TableHeaderCell>Antal</TableHeaderCell>
            <TableHeaderCell>Vikt</TableHeaderCell>
          </TableRow>
        </TableHeader>

        <TableBody>
          {items.map(({ attributes, sku, article, confirmedQuantity }) => (
            <TableRow key={sku.id}>
              <TableCell>
                <Header as="h2" textAlign="center">
                  <a
                    href={
                      attributes.includes("RXBAG")
                        ? `https://la.site.se/orderrx/${sku.id}`
                        : article.backOfficeURL
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" "}
                    {sku.id}{" "}
                  </a>
                </Header>
              </TableCell>
              <TableCell singleLine>
                <ImageWithFallback mainSrc={article.imageUrl} className="article-image-small" />
              </TableCell>
              <TableCell>{article.name}</TableCell>
              <TableCell textAlign="right">{confirmedQuantity}</TableCell>
              <TableCell>{article.weight}g</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Segment>
  );
};

export default ShippingList;
